//------------------------------REACT----------------------------------------//
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//---------------------------------MUI-------------------------------------------//
import {
  Grid,
  Grow,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
//--------------------ACTIONS--------------------
import {
  getSparePartList,
  addSparePart,
  updateSparePart,
  deleteSparePart,
  setSparePartLogList,
  getSparePartNoteList,
} from "../../store/actions/SparePartActions";

//-------------------------------COMPONENTS----------------------------------------------//
import SearchBar from "../../components/SearchBar/SearchBar";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import { downloadExcelFile } from "../../store/actions/SparePartExcelActions";
import AddButton from "../../components/AddButton/AddButton";
import TableButtons from "../../components/Button/TableButtons";
import Modal from "../../components/Modal/Modal";
import { saveSparePartLogs } from "../../api/SparePartApi";
import sparePartTypeEnum from "../../enums/sparePartTypeEnum";
import SparePartHistoryPopup from "../../components/Popup/SparePartHistoryPopup";
import sparePartActionEnum from "../../enums/sparePartActionEnum";

export default function SparePart(props) {
  const dispatch = useDispatch();
  let [rows, setRows] = useState([]);
  const { t } = useTranslation("translation");
  const [totalCount, setTotalCount] = useState(0);
  const [disableButton, setDisableButton] = useState(false);
  const [editable, setEditable] = useState(false);
  const [editableRow, setEditableRow] = useState("");
  const [isAddDisable, setIsAddDisable] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isShowHistoryOpen, setIsShowHistoryOpen] = useState(false);
  const [deletedRow, setDeletedRow] = useState([]);
  const [selectedHistoryRow, setSelectedHistoryRow] = useState([]);
  const [initialRows, setInitialRows] = useState([]);

  const [error, setError] = useState({
    materialCodeError: t("MaterialCodeErrorValidation"),
    materialDescriptionError: t("MaterialDescriptionErrorValidation"),
    noteError: t("EnterANote"),
  });

  useEffect(() => {

    let payload = {
      pageNumber: 1,
      pageSize: -1,
      searchText: ""
    };

    dispatch(getSparePartNoteList(payload));
  }, []);

  const { sparePartList, deletedSp, addSparePartRes } = useSelector(
    ({ SparePart }) => SparePart
  );

  const sparePartNoteList
    = useSelector(({ SparePart }) => SparePart.sparePartNoteList?.resultObject?.content);

  useEffect(() => {
    if (sparePartList?.resultObject) {
      setInitialRows(sparePartList?.resultObject?.content);
      setRows(sparePartList?.resultObject?.content);
      setTotalCount(sparePartList?.resultObject?.totalCount);
    }
  }, [sparePartList]);

  useEffect(() => {
    if (deletedSp?.data) {
      fetchSparePart();
    }
  }, [deletedSp]);

  useEffect(() => {
    if (addSparePartRes?.data) {
      fetchSparePart();
    }
  }, [addSparePartRes]);

  useEffect(() => {
    fetchSparePart();
  }, []);

  const fetchSparePart = (pageNumber = currentPage, pageSize = rowsPerPage) => {
    let payload = {
      currentPage: pageNumber + 1,
      pageSize: pageSize,
      searchText: filterText,
      propertyName: "",
      direction: 1,
    };
    dispatch(getSparePartList(payload));
  };

  //filter equipment table
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    setCurrentPage(0);

    let payload = {
      currentPage: currentPage + 1,
      pageSize: rowsPerPage,
      searchText: filterText,

      propertyName: "",
      direction: 1,
    };
    dispatch(getSparePartList(payload));
  }, [filterText]);

  useEffect(() => {
    if (
      error.materialCodeError === "" &&
      error.materialDescriptionError === "" &&
      error.noteError === ""
    ) {
      setIsAddDisable(false);
    } else {
      setIsAddDisable(true);
    }
  }, [error]);

  //pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const HandleChangePage = (_event, newPage) => {
    setCurrentPage(newPage);
    fetchSparePart(newPage, rowsPerPage);
    setEditable(false);
    setDisableButton(false);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setCurrentPage(0);
    fetchSparePart(currentPage, event.target.value);
  };

  //dynamic sort function
  let [sortOrder, setSortOrder] = useState();
  let [sortColumn, setSortColumn] = useState();
  const HandleSort = (order, column) => {
    setSortOrder(order);
    setSortColumn(column);
    let payload = {
      currentPage: currentPage + 1,
      pageSize: rowsPerPage,
      searchText: filterText,
      propertyName: column,
      direction: order,
    };
    dispatch(getSparePartList(payload));
  };

  const renderTableCell = (rowItems, isSortingAction = true) => {
    const directionType = sortOrder === 0 ? "asc" : "desc";
    return rowItems.map((item, index) => {
      return isSortingAction ? (
        <TableCell
          id={`sp_rowItems_TableCell_${index}_${item.id}`}
          align="center"
        >
          <TableSortLabel
            id={`sp_rowItems_TableSortLabel_${index}_${item.id}`}
            active={sortColumn === item.id}
            direction={directionType}
            onClick={() => HandleSort(sortOrder === 1 ? 0 : 1, item.id)}
            style={{ paddingLeft: 25 }}
          >
            {item.label}
          </TableSortLabel>
        </TableCell>
      ) : (
        <TableCell align="center">{item.label}</TableCell>
      );
      // }
    });
  };

  //add blank row for new plant addition
  const addBlankRowHandler = () => {
    setCurrentPage(0);
    setDisableButton(true);
    const addedBlankRow = [
      {
        id: "",
        code: "",
        name: "",
      },
    ];
    rows = addedBlankRow.concat(rows);
    setEditableRow(addedBlankRow[0].id);
    setEditable(true);
    setRows(rows);
  };

  const { updateSparePartRes } = useSelector(({ SparePart }) => SparePart);

  useEffect(() => {
    if (updateSparePartRes) {
      fetchSparePart();
    }
  }, [updateSparePartRes]);

  const updateAddHandler = (row) => {
    if (!row.noteDefinitionId || row.noteDefinitionId === "") {
      setError((prev) => ({ ...prev, noteError: t("EnterANote") }));
      return;
    }

    // update
    if (row.id !== "") {
      const data = {
        id: row.id,
        materialCode: row.materialCode,
        materialDescription: row.materialDescription,
        unit: row.unit || "",
        department: row.department || "",
        shelfNo: row.shelfNo || "",
        stockQuantity: row.stockQuantity || null,
        minimumStockQuantity: row.minimumStockQuantity || null,
        countingPlace: row.countingPlace || "",
        description: row.description || "",
        noteDefinitionId: row.noteDefinitionId || "",
      };

      const oldCount = sparePartList?.resultObject?.content?.find(
        (x) => x.id == row.id
      )?.stockQuantity;
      const newCount = row.stockQuantity;
      const totalQuantity = Math.abs(oldCount - newCount);
      let SparePartAction;
      if (oldCount < newCount) {
        //Spare Part added
        SparePartAction = sparePartActionEnum.SparePartWasAdded;
      } else {
        //Spare Part used
        SparePartAction = sparePartActionEnum.SparePartWasUsed;
      }

      const sparePart = {
        SparePartId: row.id,
        AmountUsed: totalQuantity,
      };

      const sparePartLogData = {
        TaskId: 0,
        SparePartList: [sparePart],
        Type: sparePartTypeEnum.sparePart,
        PlantId: 0,
        SparePartAction,
        SparePartNoteId: row.noteDefinitionId
      };
      saveSparePartLogs(sparePartLogData);
      dispatch(updateSparePart(data));
    }
    // add
    else {
      const data = {
        materialCode: row.materialCode,
        materialDescription: row.materialDescription,
        unit: row.unit || "",
        department: row.department || "",
        shelfNo: row.shelfNo || "",
        stockQuantity: row.stockQuantity || null,
        minimumStockQuantity: row.minimumStockQuantity || null,
        countingPlace: row.countingPlace || "",
        description: row.description || "",
        noteDefinitionId: row.noteDefinitionId || "",
      };
      dispatch(addSparePart(data));
    }
    setEditable(false);
    setDisableButton(false);
    fetchSparePart();
    setError({
      materialCodeError: t("MaterialCodeErrorValidation"),
      materialDescriptionError: t("MaterialDescriptionErrorValidation"),
      noteError: t("EnterANote"),
    });
  };

  const cloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
  };

  const disableEditHandler = () => {
    //filterData(filterText);
    setError({
      materialCodeError: t("MaterialCodeErrorValidation"),
      materialDescriptionError: t("MaterialDescriptionErrorValidation"),
      noteError: t("EnterANote"),
    });
    setEditable(false);
    //enable edit button
    setDisableButton(false);
    setRows(cloneObject(initialRows));
  };

  const enableEditHandler = (row) => {
    if (disableButton || editable) {
      //filterData(filterText);
    }
    setDisableButton(true);
    setEditableRow(row.id);
    setEditable(true);
    setRows(cloneObject(initialRows));

    setError({
      materialCodeError: "",
      materialDescriptionError: "",
      materialDepartmanError: "",
      materialUnitError: "",
      materialCountingPlaceError: "",
      materialShelfNoError: "",
      noteError: "",
    });
  };

  //modal

  const deleteButtonHandler = (row) => {
    setDeletedRow(row);
    toggleModal();
  };

  const showHistoryButtonHandler = (row) => {
    setSelectedHistoryRow(row);
    setIsShowHistoryOpen(true);
  };

  const toggleShowHistoryModal = () => {
    setIsShowHistoryOpen((prevState) => !prevState);
    setSelectedHistoryRow([]);
    dispatch(setSparePartLogList({}));
  };

  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };

  const setRowHandler = (value, obj, updatedRow) => {
    const index = rows.indexOf(updatedRow);
    if (updatedRow.id !== "") {
      const row = rows[index];
      row[obj] = value;
      rows[index] = row;
      setRows(rows);
    } else {
      const row = rows[index];
      row[obj] = value;
      setRows(rows);
    }

    if (obj === "materialCode") {
      setError({
        ...error,
        materialCodeError:
          value.trim().length === 0 ? t("MaterialCodeErrorValidation") : "",
      });
    }

    if (obj === "materialDescription") {
      setError({
        ...error,
        materialDescriptionError:
          value.trim().length === 0
            ? t("MaterialDescriptionErrorValidation")
            : "",
      });
    }

    if (obj === "noteDefinitionId") {
      if (!value || value === "") {
        setError((prev) => ({ ...prev, noteError: t("EnterANote") }));
      } else {
        setError((prev) => ({ ...prev, noteError: "" }));
      }
    }
  };

  const deleteHandler = (row) => {
    toggleModal();
    setDeletedRow(row);
    const data = {
      sparePartId: row.id,
    };
    dispatch(deleteSparePart(data));
  };

  return (
    <StyledTableDiv>
      <h1>{t("SparePartList")}</h1>
      <AddButton
        onClick={() => addBlankRowHandler()}
        disabled={disableButton}
      />
      <SparePartHistoryPopup
        open={isShowHistoryOpen}
        close={toggleShowHistoryModal}
        array={selectedHistoryRow || []}
      />
      <React.Fragment>
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ marginBottom: 4 }}
        >
          <Grid item xs={10} sm={10} md={6} lg={4}>
            <SearchBar
              value={filterText}
              onChange={(val) => setFilterText(val)}
            />
          </Grid>
          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            lg={2}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Tooltip title={t("ExcelFileOutline")}>
              <IconButton
                onClick={() => dispatch(downloadExcelFile({ data: {} }))}
                size="large"
              >
                <GetAppIcon
                  style={{ color: "#008000", width: 50, height: 50 }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </React.Fragment>
      {rows.length > 0 ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <TableContainer id="sp_TableContainer" component={Paper}>
            <Table id="sp_Table" aria-label="customized table">
              <TableHead id="sp_TableHead">
                <TableRow id="sp_TableRow">
                  {renderTableCell([
                    { id: "id", label: "ID" },
                    { id: "materialCode", label: t("StockNo") },
                    {
                      id: "materialDescription",
                      label: t("MaterialDescription"),
                    },
                    { id: "department", label: t("Department") },
                    { id: "unit", label: t("Unit") },
                    { id: "stockQuantity", label: t("WareHouseQuantity") },
                    { id: "shelfNo", label: t("ShelfNo") },
                    {
                      id: "minimumStockQuantity",
                      label: t("MinimumStockQuantity"),
                    },
                    { id: "countingPlace", label: t("PlaceToCount") },
                    { id: "description", label: t("Description") },
                    { id: "note", label: t("Note") },
                    { id: "Actions", label: t("Actions") },
                  ])}
                </TableRow>
              </TableHead>
              <TableBody id="sp_TableBody">
                {rows.map((row, index) => (
                  <TableRow id={`sp_TableRow_${index}`} key={row.id}>
                    <TableCell
                      id={`sp_TableCell_Id`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_StockNo`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_TextField_StockNo`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "materialCode", row)
                          }
                          defaultValue={row.materialCode}
                          variant="outlined"
                          error={error.materialCodeError.length > 0}
                          helperText={error.materialCodeError}
                          FormHelperTextProps={{ id: "brg_val1" }}
                          style={{ minWidth: 150 }}
                        />
                      ) : (
                        row.materialCode
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_MaterialDescription`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_TextField_MaterialDescription`}
                          onInput={(e) =>
                            setRowHandler(
                              e.target.value,
                              "materialDescription",
                              row
                            )
                          }
                          defaultValue={row.materialDescription}
                          variant="outlined"
                          error={error.materialDescriptionError.length > 0}
                          helperText={error.materialDescriptionError}
                          FormHelperTextProps={{ id: "brg_val1" }}
                          style={{ minWidth: 250 }}
                        />
                      ) : (
                        row.materialDescription
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_Department`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_TextField_Department`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "department", row)
                          }
                          defaultValue={row.department}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                        />
                      ) : (
                        row.department
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_Unit`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_Unit`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "unit", row)
                          }
                          defaultValue={row.unit}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                        />
                      ) : (
                        row.unit
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_StockQuantity`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_StockQuantity`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "stockQuantity", row)
                          }
                          defaultValue={row.stockQuantity}
                          variant="outlined"
                          type="number"
                          FormHelperTextProps={{ id: "brg_val1" }}
                          style={{ maxWidth: 70 }}
                        />
                      ) : (
                        row.stockQuantity
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_ShelfNo`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_ShelfNo`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "shelfNo", row)
                          }
                          defaultValue={row.shelfNo}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                          style={{ maxWidth: 70 }}
                        />
                      ) : (
                        row.shelfNo
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_MinimumStockQuantity`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_MinimumStockQuantity`}
                          onInput={(e) =>
                            setRowHandler(
                              e.target.value,
                              "minimumStockQuantity",
                              row
                            )
                          }
                          defaultValue={row.minimumStockQuantity}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                          type="number"
                          style={{ maxWidth: 70 }}
                        />
                      ) : (
                        row.minimumStockQuantity
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_CountingPlace`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_CountingPlace`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "countingPlace", row)
                          }
                          defaultValue={row.countingPlace}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                        />
                      ) : (
                        row.countingPlace
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_Description`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <TextField
                          id={`gt_TableCell_Description`}
                          onInput={(e) =>
                            setRowHandler(e.target.value, "description", row)
                          }
                          defaultValue={row.description}
                          variant="outlined"
                          FormHelperTextProps={{ id: "brg_val1" }}
                        />
                      ) : (
                        row.description
                      )}
                    </TableCell>
                    <TableCell
                      id={`sp_TableCell_Note`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {editable && editableRow === row.id ? (
                        <Select
                          id={`gt_TableCell_Note`}
                          value={row.noteDefinitionId || ""}
                          onChange={(e) => {
                            setRowHandler(e.target.value, "noteDefinitionId", row);
                            setRows((prev) =>
                              prev.map((r) =>
                                r.id === row.id ? { ...r, noteDefinitionId: e.target.value } : r
                              )
                            )
                          }}
                          variant="outlined"
                          error={error.noteError.length > 0}
                        >
                          {sparePartNoteList?.map((note) => (
                            <MenuItem
                              key={note.id} value={note.id}>
                              {note.note}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        sparePartNoteList?.find((x) => x.id === row.noteDefinitionId)?.note || ""
                      )}
                    </TableCell>

                    <TableButtons
                      addDisabled={isAddDisable}
                      editable={editable}
                      editableRow={editableRow}
                      row={row}
                      showHistory={true}
                      updateAddHandler={() => updateAddHandler(row)}
                      disableEditHandler={() => disableEditHandler()}
                      enableEditHandler={() => enableEditHandler(row)}
                      showHistoryButtonHandler={() =>
                        showHistoryButtonHandler(row)
                      }
                      deleteButtonHandler={() => deleteButtonHandler(row)}
                    />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              id="sp_TablePagination"
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={HandleChangePage}
              onRowsPerPageChange={HandleChangeRowsPerPage}
            />
          </TableContainer>
        </Grow>
      ) : null}

      <Modal
        title={t("Delete")}
        content={t("WillYouDoTransaction")}
        approved={() => deleteHandler(deletedRow)}
        isModalOpen={isModalOpen}
        toggle={toggleModal}
      />

      <LoadingBackdrop />
    </StyledTableDiv>
  );
}
